// @flow

import { ButtonGroup, Button } from "react-bootstrap";
import { partial } from "lodash";
import type { MeasurementUnit } from "types";
import * as React from "react";

type Props = {
  unit: MeasurementUnit,
  onSelect: MeasurementUnit => void
};

const MeasurementUnitSwitch = (props: Props) => {
  const { unit, onSelect } = props;
  let inch_style = "primary";
  let cm_style = "default";
  if (unit === "cm") {
    inch_style = "default";
    cm_style = "primary";
  }

  return (
    <ButtonGroup className={"measurement-unit-switch"}>
      <Button onClick={partial(onSelect, "inch")} bsStyle={inch_style}>
        inch
      </Button>

      <Button onClick={partial(onSelect, "cm")} bsStyle={cm_style}>
        cm
      </Button>
    </ButtonGroup>
  );
};

MeasurementUnitSwitch.displayName = "MeasurementUnitSwitch";

export default MeasurementUnitSwitch;
